import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";
import { t } from "i18next";

export type ModalSignProps = {
  onClick?: () => void;
  onClose: () => void;
  open: boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
  children?: React.ReactNode;
  title: string;
  button: React.ReactNode;
  onClean?: () => void;
};

export const ModalSign: React.FC<ModalSignProps> = ({
  onClick,
  onClose,
  open,
  acceptButtonText,
  cancelButtonText,
  children,
  title,
  button,
  onClean,
}) => (
  <Dialog open={open} onClose={onClose} className="relative z-10">
    <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <DialogPanel className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 max-h-[50vh] overflow-visible">
            <div className="mt-3 sm:ml-0 sm:mt-0">
              <div className="flex justify-between items-center">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  {title}
                </DialogTitle>
                {button}
              </div>
              <div className="mt-2">{children}</div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            {acceptButtonText && (
              <ButtonPrimaryModal text={acceptButtonText} onClick={onClick} />
            )}
            {cancelButtonText && (
              <ButtonSecondaryModal text={cancelButtonText} onClick={onClose} />
            )}
            {onClean && (
              <button
                onClick={onClean}
                type="button"
                className="mr-3 mt-3 inline-flex w-full justify-center rounded bg-indigo-50 px-3 py-2 text-sm font-semibold text-primary-600 shadow-sm hover:bg-indigo-100 sm:mt-0 sm:w-auto"
              >
                {t("user.views.clean")}
              </button>
            )}
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
